import { safeDefineElement } from '@/scripts/core/global'

import { MainSearch } from '@/scripts/catalog/main-search'
import { CollectionNav } from '@/scripts/catalog/collection-nav'
import { CollectionTagFilter } from '@/scripts/catalog/collection-tag-filter'

safeDefineElement(MainSearch)
safeDefineElement(CollectionNav)
safeDefineElement(CollectionTagFilter)
